export default __webpack_public_path__ + "static/media/img-slider-cmbus-8.d24e9991.png";